import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {handleResetPassword} from '../../../modules/profile'
import {Field, reduxForm} from "redux-form"
import RenderPasswordFormGroup from "../Form/RenderPasswordFormGroup"
import {required} from "../Form/rules"
import {translationsLocaleSelector} from "../../../modules/app"


class HandleReset extends Component{
    render() {
        let {handleSubmit, token, error, submitting, submitSucceeded} = this.props

        let {formatMessage} = this.context

        return (
            <div className="auth-form-wrapper">
                <h1 className="h2 text-center">{formatMessage('resetingPassword')}</h1>
                <p className="text-center">{formatMessage('Please choose your new password:')}</p>
                <form className="profile-form" onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                name = "password"
                                type = "password"
                                component = {RenderPasswordFormGroup}
                                label = {`${formatMessage("Password")}:`}
                                id = "password"
                                validate = {[required]}
                            />
                        </div>
                    </div>

                    {
                        submitSucceeded &&
                        <div className="row">
                            <div className="col-xs-12 text-center text-success">
                                <p>{formatMessage("newPasswordSavedTryToLogin")}</p>
                            </div>
                        </div>
                    }

                    {
                        !token &&
                        <div className="row">
                            <div className="col-xs-12 text-center text-danger">
                                <p>{formatMessage('tokenParamIsRequired')}</p>
                            </div>
                        </div>
                    }

                    {
                        error &&
                        <div className="row">
                            <div className="col-xs-12 text-center text-danger">
                                <p>{formatMessage(error)}</p>
                            </div>
                        </div>
                    }

                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-group">
                                <button className="btn btn-primary btn-block" type="submit" disabled={submitting}>{formatMessage("Reset")}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => ({
        locale : translationsLocaleSelector(state),
    }),
    null,
    null,
    {pure: false}
)(reduxForm({
    form: 'reset-password',
    onSubmit : (values, dispatch, ownProps) => {
        let {password} = values
        let {token} = ownProps
        return handleResetPassword({token, password})
    },
    pure: false,
})(HandleReset))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Auth/HandleReset.js